// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__sJK7M","info":"Panel_info__kYpOa","note":"Panel_note__O9Rqg","close":"Panel_close__UwubF","btns":"Panel_btns__biKn0","button":"Panel_button__jyC15"};